
import Vue from 'vue'
import MainLayout from '@/components/MainLayout.vue';

export default Vue.extend({
	name: 'Home',
	components: {
		MainLayout,
	}
});
